// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';

export type AnalyticsEventType =
  | 'pageView'
  | 'purchase'
  | 'error'
  | 'voucherGenerate'
  | 'purchaseAttempt'
;

export class AnalyticsProvider {
  incomingPayment: IncomingPayment;
  userInputValues: UserInputValues;
  submitError: ?PlaceOrderErrorPayload;

  setUserInputValues(userInputValues: UserInputValues) {
    this.userInputValues = userInputValues;
  }

  setSubmitError(submitError: ?PlaceOrderErrorPayload) {
    this.submitError = submitError;
  }

  init(incomingPayment: IncomingPayment): bool {
    this.incomingPayment = incomingPayment;
    return false;
  }

  onEvent(eventType: AnalyticsEventType) {
    return void eventType;
  }

}

export type AnalyticsManager = {|
  +setUserInputValues: (UserInputValues) => void,
  +setSubmitError: (?PlaceOrderErrorPayload) => void,
  +event: (AnalyticsEventType) => void,
  +eventOnce: (AnalyticsEventType, IncomingPayment) => void,
|};
